import validate from "/Users/wilmerhenao/triduum/t&t/t2t-front/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/Users/wilmerhenao/triduum/t&t/t2t-front/middleware/auth.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global
]
export const namedMiddleware = {}